import EmailThemes from "@/models/loyaltyPanel/campaigns/EmailThemes";
import _ from "lodash";
import router from "../../../../routes";

export default {
    namespaced: true,

    state: () => ({
        emailThemes: [],
        theme: {},
        pagination: {},
    }),

    mutations: {
        setEmailThemes(state, payload){
            state.emailThemes = payload;
        },
        setTheme(state, payload){
            state.theme = payload;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        },
    },

    actions: {
        async getEmailThemes({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await EmailThemes.getAll(payload);
                const { store_email_themes, pagination } = data.data;
           
                commit("setEmailThemes", store_email_themes);
                commit("setPagination", pagination);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        
        async getTheme({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await EmailThemes.getOne(id);
                commit("setTheme", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        

        async uploadThumbnail({ commit, rootState }, { image }) {
            try {
                commit("setLoading", true, { root: true });

                const fd = new FormData();
                fd.append("image", image);
                const { data } = await EmailThemes.uploadThumbnail(fd);

                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: `You have successfully uploaded the image!`
                    },

                    { root: true }
                );
                commit("setLoading", false, { root: true });

                return data.data;
            } catch (ex) {
                commit("setLoading", false, { root: true });

                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message
                    },
                    { root: true }
                );
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
                commit("setLoading", false, { root: true });

                return false;
            }
        },
        
        async createTheme({ commit, state }, newTheme) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await EmailThemes.create({ ...newTheme });

                if (data.status == "success") {
                    commit('setEmailThemes', [...state.emailThemes, {...data.data}])
                    commit("setLoading", false, { root: true });
                    commit("setDialog", false, { root: true });
                    commit(
                        "setNotification",
                        {
                            show: true,
                            type: "success",
                            text: "You have successfully created theme!"
                        },

                        { root: true }
                    );

                    // router.push("/en/loyaltyPanel/campaigns/email-themes");
                }
                commit("setLoading", false, { root: true });

                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message 
                    },
                    { root: true }
                );
                setTimeout(
                    () => commit("setNotification", "", { root: true }),
                    5000
                );
            }
        },
        
        async updateTheme({ commit, state }, theme) {
            try {
                commit("setLoading", true, { root: true });

                let themeData = _.cloneDeep(theme);

                const { data } = await EmailThemes.update(themeData);

                if (data.status == "success") {
                    let themes = _.cloneDeep(state.emailThemes)

                    let themeIndex = themes.findIndex(x => x.store_email_theme_id == themeData.store_email_theme_id)
                    themes[themeIndex] = {...data.data}
                    commit('setEmailThemes', themes)

                    commit("setDialog", false, { root: true });
                    commit(
                        "setNotification",
                        {
                            show: true,
                            type: "success",
                            text: "You have successfully updated theme!"
                        },

                        { root: true }
                    );

                    commit('setTheme', {})

                }
                
                commit("setLoading", false, { root: true });
                return data


            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || `Error: ${ex}`
                    },

                    { root: true }
                );
                setTimeout(
                    () => commit("setNotification", "", { root: true }),
                    5000
                );
            }
        },
        
        
        async deleteTheme({ commit, state }, theme) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await EmailThemes.delete(theme);

                if (data.message.includes("DELETED")) {
                    
                    commit("setEmailThemes", state.emailThemes.filter(e => e.store_email_theme_id != theme.store_email_theme_id))
                    commit("setDialog", false, { root: true });
                    commit(
                        "setNotification",
                        {
                            show: true,
                            type: "success",
                            text: "You have successfully deleted the email theme!"
                        },

                        { root: true }
                    );

                }
                commit("setLoading", false, { root: true });
                return true
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message
                    },

                    { root: true }
                );
                setTimeout(
                    () => commit("setNotification", "", { root: true }),
                    5000
                );
            }
        },
    }
};
